import { render, staticRenderFns } from "./borrarSesion.vue?vue&type=template&id=d53e682a&"
import script from "./borrarSesion.vue?vue&type=script&lang=js&"
export * from "./borrarSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports